<template>
  <div
    uk-sticky="sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky; bottom: #transparent-sticky-navbar"
  >
    <nav
      class="uk-navbar-container uk-navbar-transparent uk-background-secondary"
      uk-navbar
      style="position: relative; z-index: 980;"
    >
      <div class="uk-navbar-left">
        <ul class="uk-navbar-nav">
          <li uk-toggle="target: #offcanvas-usage">
            <a>
              <span uk-navbar-toggle-icon class="uk-margin-small-right"></span>
              Menu
            </a>
          </li>
          <li><a href="#profile">Profile</a></li>
          <li><a href="#projects">Projects</a></li>
          <li><a href="#notes">Notes</a></li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "TopBar",
};
</script>

<style scoped>
a {
  font-family: "overpass", sans-serif;
  font-weight: 600;
  font-style: normal;
}
</style>
